<template>
  <div :class="['ms-form', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-truck-field" aria-hidden="true" />Основное</h3>
        <div class="ms-form-grid">
          <CustomInput label="Наименование" type="text" :required="true" :value="this.formData.provider_name"
            @change_input="(value) => onChange('provider_name', value)" />
          <CustomInput label="БИН" type="text" :required="true" :value="this.formData.bin"
            @change_input="(value) => onChange('bin', value)" />
          <CustomSelect :options="providerTypeOptions" label="Тип поставщика" :required="true"
            optionValueKey="provider_type_id" optionLabelKey="provider_type_name"
            :value="this.formData.provider_type_id || ''"
            @change="(value) => onChange('provider_type_id', value)" />
          <CustomSelect :options="contragentTypeOptions" label="Тип контрагента" optionValueKey="contragent_type_id"
            optionLabelKey="contragent_type_name" :value="this.formData.contragent_type_id || ''"
            @change="(value) => onChange('contragent_type_id', value)" />
          <CustomInput label="Маржа материала" type="text" :value="this.formData.material_marzha"
            @change_input="(value) => onChange('material_marzha', value)" />
          <CustomInput label="ГУИД" type="text" :value="this.formData.guid"
            @change_input="(value) => onChange('guid', value)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-address-card" aria-hidden="true" />Руководитель и контакты</h3>
        <div class="ms-form-grid">
          <CustomInput label="Полное ФИО Директора" type="text" :value="this.formData.director_fio"
            class="ms-form-wide" @change_input="(value) => onChange('director_fio', value)" />
          <CustomInput label="Телефон" type="text" :required="true" :value="this.formData.phone"
            @change_input="(value) => onChange('phone', value)" />
          <CustomInput label="Email" type="email" :value="this.formData.provider_email"
            @change_input="(value) => onChange('provider_email', value)" />
          <CustomSelect :options="countryOptions" label="Страна резидентства" :required="true"
            optionValueKey="contragent_country_id" optionLabelKey="country_name"
            :value="this.formData.contragent_country_id || ''"
            @change="(value) => onChange('contragent_country_id', value)" />
          <CustomSelect :options="cityOptions" label="Город" :required="true" optionValueKey="city_id"
            optionLabelKey="city_name" :value="this.formData.city_id || ''"
            @change="(value) => onChange('city_id', value)" />
          <CustomInput label="Адрес" type="textarea" :required="true" :value="this.formData.address"
            class="ms-form-wide" @change_input="(value) => onChange('address', value)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-building-columns" aria-hidden="true" />Банковские реквизиты</h3>
        <div class="ms-form-grid">
          <CustomInput label="ИИК" type="text" :value="this.formData.iik"
            @change_input="(value) => onChange('iik', value)" />
          <CustomInput label="Наименование банка" type="text" :value="this.formData.bank_name"
            @change_input="(value) => onChange('bank_name', value)" />
          <CustomInput label="БИК" type="text" :value="this.formData.bik"
            @change_input="(value) => onChange('bik', value)" />
          <CustomInput label="КБе" type="number" :value="this.formData.kbe"
            @change_input="(value) => onChange('kbe', value)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-file-signature" aria-hidden="true" />Договор и комментарий</h3>
        <div class="ms-form-grid">
          <CustomInput label="Текст для договора" type="textarea" :value="this.formData.contract_text"
            @change_input="(value) => onChange('contract_text', value)" />
          <CustomInput label="Комментарий" type="textarea" :value="this.formData.comment"
            @change_input="(value) => onChange('comment', value)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-sliders" aria-hidden="true" />Настройки</h3>
        <div class="ms-form-grid provider-form__checks">
          <CustomCheckbox label="Плательщик НДС" :value="this.formData.is_nds" :binary="true"
            @change="(value) => onChange('is_nds', value)" />
          <CustomCheckbox label="Запрет на создание автоматических платежей"
            :value="this.formData.is_not_create_auto_payment"
            @change="(value) => onChange('is_not_create_auto_payment', value)" />
          <CustomCheckbox label="Показывать цену до скидки" :value="this.formData.is_show_old_price" :binary="true"
            @change="(value) => onChange('is_show_old_price', value)" />
          <CustomCheckbox label="Подписка на рассылку" :value="this.formData.is_subscribe" :binary="true"
            @change="(value) => onChange('is_subscribe', value)" />
          <CustomCheckbox label="Автоматическая отправка заявок по ГПР" :value="this.formData.is_auto_gpr" :binary="true"
            @change="(value) => onChange('is_auto_gpr', value)" />
          <CustomCheckbox label="Доставка в субботу" :value="this.formData.is_saturday_delivery" :binary="true"
            @change="(value) => onChange('is_saturday_delivery', value)" />
        </div>
      </section>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import { getCity, getProviderCountry, getContragentType, getProviderType } from "@/views/handbook/Providers/services";

export default {
  name: "add-handbook-provider",
  components: { CustomCheckbox, CustomModalFooter, CustomInput, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        is_not_create_auto_payment: this.data?.body?.is_not_create_auto_payment || false,
        provider_name: this.data?.body?.provider_name || '',
        material_marzha: this.data?.body?.material_marzha || '',
        is_nds: this.data?.body?.is_nds || 0,
        director_fio: this.data?.body?.director_fio || '',
        guid: this.data?.body?.guid || '',
        bin: this.data?.body?.bin || '',
        address: this.data?.body?.address || '',
        city_id: this.data?.body?.city_id || '',
        provider_type_id: this.data?.body?.provider_type_id || '',
        contragent_type_id: this.data?.body?.contragent_type_id || '',
        iik: this.data?.body?.iik || '',
        bank_name: this.data?.body?.bank_name || '',
        bik: this.data?.body?.bik || '',
        kbe: this.data?.body?.kbe || '',
        contract_text: this.data?.body?.contract_text || '',
        phone: this.data?.body?.phone || '',
        provider_email: this.data?.body?.provider_email || '',
        comment: this.data?.body?.comment || '',
        is_show_old_price: this.data?.body?.is_show_old_price || 0,
        is_subscribe: this.data?.body?.is_subscribe || 0,
        is_auto_gpr: this.data?.body?.is_auto_gpr || 0,
        is_saturday_delivery: this.data?.body?.is_saturday_delivery || 0,

      },
      cityOptions: [], 
      countryOptions: [],  
      contragentTypeOptions: [], 
      providerTypeOptions: [], 
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
    async fetchCities() {
      this.cityOptions = await getCity();
    },
    async fetchCountries() {
      this.countryOptions = await getProviderCountry();
    },
    async fetchContragentType() {
      this.contragentTypeOptions = await getContragentType();
    },
    async fetchProviderType() {
      this.providerTypeOptions = await getProviderType();
    },
  },
  mounted() {
    this.fetchCities();
    this.$watch('cityOptions', (newOptions) => {
      if (newOptions.length && !this.formData.city_id) {
        this.formData.city_id = newOptions[0].city_id;
      }
    });
    this.fetchCountries();
    this.$watch('countryOptions', (newOptions) => {
      if (newOptions.length && !this.formData.contragent_country_id) {
        this.formData.contragent_country_id = newOptions[0].contragent_country_id;
      }
    });
    this.fetchContragentType();
    this.fetchProviderType();
  }
}
</script>

<style scoped lang="scss">
// Блоки, сетка и ширина — общие (ms-form-* в theme.scss)
.provider-form__checks {
  row-gap: 2px;
  margin-left: -8px;
}
</style>
